module.exports = __webpack_public_path__ + "6ca7bf750ebc831b8c9c5b135abcebe8.svg";